import React from 'react';
import { connect } from 'react-redux';
import AsyncSelect from "react-select/async";
import axios from 'axios';
import ErrorValidation from '../../../services/ErrorValidation';
import Ax from '../../../components/hoc/Ax';
import ReactSelectStyle from '../../../components/ui/ReactSelectStyle';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import api from '../../../services/api';

class InputFuelVendorSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state                  =   {
            selectedFuelVendor          :   null,
            timer                       :   false,
            defaultOptions              :   [],
        };
        this.cancelToken            =   null;
        this.apiTimeout             =   null;
        this.fuelVendorUrl          =   IAM_API_BASE_URL_2 + '/' + 'fuel_vendor_list';
    }
    
    initParams                          =   (props)  =>  {
        this.setState({
            params                      :   {
                cl_attribute                :   props.clAttribute,
                search_name                 :   props.search_name,
            }
        }, () => {
            if(this.props.loadDefaultOptions == true) {
                this.getDefaultOptions();
            }
        });
    }
    
    componentDidMount() {
        this.initParams(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.search_site_id !== this.props.search_site_id) {
            this.initParams(nextProps);
        }
    }

    onInputChange                   =   (selectedOption)  =>  {
        this.props.changeEvent(selectedOption);
    }
    
    displayStringSearch             =   (fuelVendors)  =>  {
        return fuelVendors.map(fuelVendor => {
            return {
                label               :   fuelVendor.name,
                value               :   fuelVendor.enc_id,
                display_label       :   fuelVendor.name,
                fuelVendor          :   fuelVendor
            };
        });
    };
    
    loadingOptions                  =   (inputText,callback)  =>  {
        if(inputText.length > 2) {
            clearTimeout(this.apiTimeout)
            if (this.cancelToken) {
                this.cancelToken.cancel("Operation canceled due to new request.")
            }
            this.cancelToken = axios.CancelToken.source();

            // search_site_id : this.props.search_site_id ? this.props.search_site_id : ''
            let params          = {...this.state.params, search_by_text: inputText, per_page: 50};
            if(this.props.search_is_linked && this.props.search_is_linked) {
                params      =   {...params , search_is_linked : this.props.search_is_linked};
            }
            this.apiTimeout  = setTimeout(() => {this.getLoadingOptions(params,callback)},1000);
        }
    }

    getLoadingOptions         =        (params,callback)            =>         {
         api.server2Api({
             method: 'GET',
             headers: { 'Authorization': 'Bearer ' + this.props.access_token },
             params: params,
             url: this.fuelVendorUrl,
             cancelToken: this.cancelToken.token
         })
        .then((response) => {
            callback(this.displayStringSearch(response.data.data))
        }).catch((err) => {
            if (axios.isCancel(err)) {
              
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to Get / Save Application Data.');
            }
        });
    }

    getDefaultOptions               =       ()              =>          {
        this.setState({defaultOptions : []});
          HttpAPICall.withAthorization('GET', this.fuelVendorUrl, this.props.access_token,   this.state.params, {})
        .then((response) => {
            this.setState({
                defaultOptions:     this.displayStringSearch(response.data.data)
            });
        }).catch((err) => {
            if (axios.isCancel(err)) {
               
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to Get / Save Application Data.');
            }
        });
        
      
//        this.getLoadingOptions()
    }
    
    render() {
          return (<Ax>
            <AsyncSelect
                styles          =   {ReactSelectStyle(this.props)}
                menuPlacement   =   {this.props.menuPlacement || "bottom"}
                placeholder     =   {this.props.placeholder || "Search Fuel Vendor" }
                loadingMessage  =   {(input) => {
                    if(input.inputValue && input.inputValue.length <=2 ) {
                        return 'Please enter 3 or more characters';
                    } else {
                        return 'Searching...';
                    }
                }}
                noOptionsMessage  =   {(input) => {
                    if(input.inputValue.length == 0) {
                        return 'Please enter 3 or more characters';
                    } else {
                        return 'No Fuel Vendor found';
                    }
                }}
                minimumInput    =   {5}
                complete        =   {true}
                onChange        =   {this.onInputChange}
                isClearable     =   {true}
                loadOptions     =   {this.loadingOptions}
                value           =   {this.props.value}
                isMulti         =   {this.props.isMulti || false}
                required        =   {true}
                isDisabled      =   {this.props.disabled || false}
                defaultOptions  =   {this.props.loadDefaultOptions == true ? this.state.defaultOptions  : null }
            />
            <input
                name=''
                tabIndex={-1}
                required={this.props.required || false}
                value={this.props.isMulti ? (this.props.value.length > 0 ? this.props.value[0].label : [].join(' ')) : (this.props.value ? this.props.value.label : '')}
                onChange={() => {} }
                style={{
                    opacity: 0,
                    width: 0,
                    height: 0,
                    padding: 0,
                    margin: 0,
                    display: 'table'
                  }}
            />        
            </Ax>);
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token
    };
};

export default connect(mapStateToProps)(InputFuelVendorSearch);